import { ArrowBack } from '@mui/icons-material';
import { Stack, IconButton } from '@mui/material';
import { useBackButton } from '../../contexts/BackButtonContext';

interface Props {
  children?: any;
  fallbackPath?: string;
}

const BackButton: React.FC<Props> = ({ children, fallbackPath }) => {
  const { isVisible, hasInAppHistory, goBack } = useBackButton();
  const showButton = isVisible || (!!fallbackPath && !hasInAppHistory);

  if (!showButton && !children) return null;

  return (
    <Stack direction="row" alignItems={'center'} spacing={1}>
      {showButton && (
        <IconButton aria-label="Back" onClick={() => goBack(fallbackPath)}>
          <ArrowBack />
        </IconButton>
      )}
      {children}
    </Stack>
  );
};

export default BackButton;
